var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0442 4.33593C14.8247 3.55429 16.0905 3.55381 16.8716 4.33486L19.3634 6.82672C20.1378 7.6011 20.1458 8.85475 19.3815 9.63902L17.7215 11.3421L12.381 6.00162L14.0442 4.33593ZM11.3212 7.06308L16.6745 12.4164L10.1483 19.1123C9.58389 19.6914 8.80976 20.0179 8.00142 20.0179L5.24927 20.0178C4.39644 20.0177 3.71536 19.3068 3.75123 18.4541L3.86939 15.6451C3.90098 14.8938 4.21321 14.1818 4.74428 13.65L11.3212 7.06308ZM20.5148 20.6951C20.9289 20.6951 21.2645 20.3592 21.2645 19.9448C21.2645 19.5304 20.9289 19.1945 20.5148 19.1945H14.3931C13.979 19.1945 13.6434 19.5304 13.6434 19.9448C13.6434 20.3592 13.979 20.6951 14.3931 20.6951H20.5148Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.1bedf18cdf934197fbc51d0352c2cffb.svg";
export { ForwardRef as ReactComponent };